import { render, staticRenderFns } from "./menu-manger.vue?vue&type=template&id=5b2a34e1&scoped=true&"
import script from "./menu-manger.vue?vue&type=script&lang=js&"
export * from "./menu-manger.vue?vue&type=script&lang=js&"
import style0 from "./menu-manger.vue?vue&type=style&index=0&id=5b2a34e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2a34e1",
  null
  
)

export default component.exports